import React, { useState } from 'react';

const Form = (props) => {

    const [inputValue, setInputValue] = useState("");

    const handleInputChange = (event) => {
        setInputValue(event.target.value);
    };

    const handleSubmit = (e) => {
        if (inputValue.trim() != ""){
        props.addTodo({title: inputValue, isDone: false});  // callback to add the todoItem
        setInputValue("");
        }
        else {
            alert("Todo item cannot be empty");
        }
        e.preventDefault();
        
    };

    return (
        <form className="ui form" onSubmit={handleSubmit}>
            <div className="ui grid center aligned">
                <div className="row">
                    <div className="column five wide">
                        <input type="text" placeholder="Enter a todo item.." value={inputValue} onChange={handleInputChange} />
                    </div>
                    <div className="column one wide">
                        <button type="submit" className="ui button circular icon green"><i className="white plus icon"></i></button>
                    </div>
                </div>
            </div>
        </form>
    );
};

export default Form;

//Semantic ui grid system has 16 columns in total